import { createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  isMobile: boolean;
}

const useStyles = makeStyles(() =>
  createStyles({
    card: {
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '455px'),
      height: 'auto',
      background: '#FFFFFF',
      border: '1px solid #FFFFFF',
      opacity: 1,
      margin: '40px 0',
      padding: 40,
      borderRadius: 20,
    },
    divCard: {
      display: 'flex',
      justifyContent: 'center',
    },
    textfield: {
      marginBottom: '30px',
      fontFamily: 'SuraSans-Regular',
      fontSize: '16px',
      '& label.Mui-focused': {
        color: '#2D6DF6',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: '#B4B4B5',
      },
    },
    input: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '16px',
      color: '#000',
      '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
        display: 'none',
      },
      '& input[type=number]': {
        MozAppearance: 'textfield',
      },
    },
    divs: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    checked: {
      '&$checked': {
        color: '#2D6DF6',
      },
    },
    root: {
      color: '#2D6DF6',
      marginTop: '-7px',
    },
    divNotice: {
      display: 'flex',
      alignItems: 'flex-start',
      marginBottom: 20,
    },
    labelNotice: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '16px',
      color: '#000000',
      paddingRight: '10px',
    },
    labelSpan: {
      color: '#00AEC7',
    },
    labelPayment: {
      fontFamily: 'SuraSans-Negrita',
      fontSize: '26px',
      color: '#000000',
    },
    labelExtraBold: {
      fontFamily: 'SuraSans-Extranegrita',
    },
    link: {
      '&:hover': {
        textDecoration: 'none',
      },
    },
    divider: {
      margin: '50px 0 15px 0',
      width: 'auto',
      color: '#B4B4B5',
      height: '1px',
    },
    divIcons: {
      display: 'flex',
      justifyContent: 'space-evenly',
    },
    divid: {
      width: 'auto',
      color: '#B4B4B5',
      height: '1px',
      margin: '15px 0 20px 0',
    },
    divMonth: {
      width: ({ isMobile }: StyleProps) => (isMobile ? '300px' : '368px'),
      height: '46px',
      border: '1px solid #B4B4B5',
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      '&.divMonthTop': {
        borderRadius: '10px 10px 0px 0px',
        marginTop: '10px',
      },
      '&.divMonthBottom': {
        borderRadius: '0px 0px 10px 10px',
        marginBottom: '10px',
      },
      '&.divCenter': {
        borderRadius: 0,
      },
    },
    checkedRadio: {
      '&.Mui-checked': {
        color: '#2D6DF6',
      },
      alignSelf: 'center',
    },
    rootRadio: {
      color: '#2D6DF6',
      alignSelf: 'center',
    },
    labelOption: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '16px',
      marginLeft: '5px',
      '&.selected': {
        color: '#000000',
      },
      '&.notSelected': {
        color: '#888B8D',
      },
    },
    subscriptionCardContainer: {
      opacity: 1,
      width: '100%',
      marginTop: '40px',
    },
    subscriptionCardLeftMiddleContainer: {
      boxShadow: '0px 3px 6px #00000029',
      borderRadius: '20px',
    },
    subscriptionCardLeft: {
      background: '#F5F8FF 0% 0% no-repeat padding-box',
      borderTopLeftRadius: '20px',
      borderBottomLeftRadius: '20px',
      opacity: 1,
      padding: '25px',
    },
    subscriptionCardMiddle: {
      background: '#FFFFFF',
      opacity: 1,
      padding: '25px 50px',
      borderTopRightRadius: '20px',
      borderBottomRightRadius: '20px',
    },
    subscriptionCardRight: {
      background: 'transparent',
      padding: ({ isMobile }: StyleProps) => (isMobile ? '20px 20px 0' : '0px 20px'),
    },
    labelSubscriptionDetailTitle: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '22px',
      color: '#0033A0',
    },
    subscriptionCardLeftContent: {
      marginTop: '22px',
    },
    labelSubscriptionDetailSubTitle: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '12px',
      color: '#888B8D',
    },
    labelSubscriptionDetailContent: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '14px',
      color: '#0033A0',
    },
    subscriptionCardMiddleForm: {
      marginTop: '20px',
    },
    subscriptionPaymentInformation: {
      background: '#2D6DF6',
      opacity: 1,
      padding: '25px',
      borderRadius: '20px',
      width: ({ isMobile }: StyleProps) => (isMobile ? '100%' : '264px'),
    },
    labelSubscriptionDetaiContent: {
      fontFamily: 'SuraSans-Ligera',
      fontSize: '16px',
      color: '#FFFFFF',
      fontStyle: 'italic',
    },
    labelDomiciliacion: {
      fontFamily: 'SuraSans-Regular',
      fontSize: '16px',
      color: '#000000',
    },
    subscribeButton: {
      marginTop: '28px',
      background: '#E3E828',
      color: '#0133A0',
      width: '100%',
      height: '40px',
      borderRadius: '28px',
      fontFamily: 'SuraSans-Seminegrita',
      fontSize: '16px',
      padding: '10px',
      border: 'none',
      '&:hover': {
        background: '#E3E828',
        textTransform: 'none',
      },
      '& > span > div > svg': {
        color: '#2D6DF6 !important',
      },
    },
    bubbleImg: {
      width: '100%',
      height: ({ isMobile }: StyleProps) => (isMobile ? 'auto' : '130px'),
    },
  }),
);

export default useStyles;
